import CoreComponent from '../../core/CoreComponent.vue';
export default {
  extends: CoreComponent
};